module.exports = __webpack_public_path__ + "static/media/loading_spinner.45160cbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_spinner.svg
// module id = 1288
// module chunks = 0